import { Injectable } from '@angular/core';
import { GenericResponse } from '../generic-response';
import { UserDataService } from './user-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RefreshTokenResponse } from 'src/app/core/model/authentication-response-model';
import { baseUrl } from 'src/app/global-variables';
import { LogoutService } from './logout.service';

@Injectable({
  providedIn: 'root',
})
export class UserRefreshTokenService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private logoutService: LogoutService
  ) {}

  public refreshToken(): Promise<GenericResponse> {
    let response: GenericResponse;
    if (
      this.userDataService.getToken() &&
      this.userDataService.getRefreshToken()
    ) {
      const refreshToken = this.userDataService.getRefreshToken();
      const headerDict = this.userDataService.getHeaderDict();
      return this.http
        .post<RefreshTokenResponse>(
          baseUrl + 'api/v2/users/refresh',
          {
            refreshToken,
          },
          {
            headers: new HttpHeaders(headerDict),
          }
        )
        .toPromise()
        .then((res) => {
          if (res.success) {
            this.userDataService.saveToken(res.token);
            this.userDataService.saveRefreshToken(res.refreshToken);
          } else {
            this.logoutService.logout(false);
          }
          response = new GenericResponse(res.success);
          return response;
        })
        .catch((e) => {
          this.logoutService.logout(false);
          response = new GenericResponse(false);
          return response;
        });
    } else {
      this.logoutService.logout(false);
      response = new GenericResponse(false);
      return Promise.resolve(response);
    }
  }
}
